module.exports = __webpack_public_path__ + "static/media/i_pad.27dbbe7d.svg";